import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import state from './state'
// import * as getters from './getters'
import * as mutations from './mutations' 
// import * as actions from './actions'

let store = new Vuex.Store({
    state,
    mutations
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js